import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { CheckIcon, ClockIcon } from 'lucide-react';
export function FinalCTA() {
  return <section className="w-full bg-[#0E2238] py-20 px-4 sm:px-6 lg:px-8" data-id="element-54">
      <div className="max-w-5xl mx-auto" data-id="element-55">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-gradient-to-br from-[#132A44] to-[#0B1C2C] border-2 border-[#2F6BFF] rounded-2xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-56">
          <div className="absolute inset-0 bg-gradient-to-br from-[#2F6BFF]/10 to-transparent" data-id="element-57"></div>

          <div className="relative z-10" data-id="element-58">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="inline-block mb-6" data-id="element-59">
              <span className="px-6 py-3 bg-red-500/20 border border-red-500/50 rounded-full text-red-400 font-bold text-sm" data-id="element-60">
                ⚡ SOLO POR HOY
              </span>
            </motion.div>

            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black text-[#F2F4F8] mb-6" data-id="element-61">
              Deja de Perder Dinero en{' '}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#2F6BFF] to-[#7EC8FF]" data-id="element-62">
                Creatina Sobrevalorada
              </span>
            </h2>

            <p className="text-xl text-[#F2F4F8]/80 mb-8 max-w-2xl mx-auto" data-id="element-63">
              Obtén acceso inmediato al manual completo + 4 bonos exclusivos
            </p>

            <div className="bg-[#0B1C2C]/50 border border-[#2F6BFF]/30 rounded-xl p-6 mb-8 max-w-2xl mx-auto" data-id="element-64">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-left" data-id="element-65">
                <div className="flex items-start gap-3" data-id="element-66">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-67" />
                  <span className="text-[#F2F4F8]/90" data-id="element-68">
                    Manual completo en PDF
                  </span>
                </div>
                <div className="flex items-start gap-3" data-id="element-69">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-70" />
                  <span className="text-[#F2F4F8]/90" data-id="element-71">4 bonos exclusivos</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-72">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-73" />
                  <span className="text-[#F2F4F8]/90" data-id="element-74">Acceso instantáneo</span>
                </div>
                <div className="flex items-start gap-3" data-id="element-75">
                  <CheckIcon className="w-5 h-5 text-green-400 flex-shrink-0 mt-1" data-id="element-76" />
                  <span className="text-[#F2F4F8]/90" data-id="element-77">
                    Actualizaciones gratis
                  </span>
                </div>
              </div>
            </div>

            <div className="mb-8" data-id="element-78">
              <div className="flex items-center justify-center gap-4 mb-4" data-id="element-79">
                <span className="text-3xl text-[#F2F4F8]/50 line-through" data-id="element-80">
                  $128.900
                </span>
                <span className="text-5xl font-black text-[#2F6BFF]" data-id="element-81">
                  $19.990
                </span>
              </div>
              <p className="text-[#F2F4F8]/70" data-id="element-82">
                Precio especial de lanzamiento — Sube pronto
              </p>
            </div>

            <CTAButton size="large" className="mb-6" data-id="element-83">
              Obtener Acceso Inmediato →
            </CTAButton>

            <div className="flex items-center justify-center gap-2 text-sm text-[#F2F4F8]/60" data-id="element-84">
              <ClockIcon className="w-4 h-4" data-id="element-85" />
              <span data-id="element-86">Acceso instantáneo después del pago</span>
            </div>

            <div className="mt-8 pt-8 border-t border-[#2F6BFF]/20" data-id="element-87">
              <p className="text-[#F2F4F8]/70 text-sm" data-id="element-88">
                🔒 Pago seguro • 💯 Garantía 7 días • 📧 Actualizaciones Gratis
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-12 text-center" data-id="element-89">
          <p className="text-[#F2F4F8]/60 text-sm max-w-2xl mx-auto" data-id="element-90">
            © 2026 El Manual Prohibido De La Creatina: Todo Lo Que Las Marcas
            No Te Cuentan. Todos los derechos reservados.
          </p>
        </motion.div>
      </div>
    </section>;
}